import breakpointValue from './breakpointValue';

export default function breakpoint(breakpoint) {
    return window.innerWidth > breakpointValue(breakpoint);
}
